import { Actions, thunk } from 'easy-peasy';
import {
  IThunkRestoreTeam,
  IClientDetailsStore,
  IClientDetailsActions,
} from '~/store/clientDetails/types';
import api from '~/services/api';

const onRestoreTeam: IThunkRestoreTeam = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientTeams.restoreTeam(payload);

    const actTeams = localState.actTeams.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: false },
    );

    setClientDetails({ actTeams });
  },
);

export default onRestoreTeam;
